import { render, staticRenderFns } from "./PraticaPage.vue?vue&type=template&id=77c36440&scoped=true&"
import script from "./PraticaPage.vue?vue&type=script&lang=js&"
export * from "./PraticaPage.vue?vue&type=script&lang=js&"
import style0 from "./PraticaPage.vue?vue&type=style&index=0&id=77c36440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c36440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c36440')) {
      api.createRecord('77c36440', component.options)
    } else {
      api.reload('77c36440', component.options)
    }
    module.hot.accept("./PraticaPage.vue?vue&type=template&id=77c36440&scoped=true&", function () {
      api.rerender('77c36440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/PraticaPage.vue"
export default component.exports